var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { DropdownMenuItem } from '../dropdown-menu-item';
import { DropdownMenuListItem } from '../dropdown-menu-list-item';
import { styled } from '../../styled';
import { dropdownMenuGroupClasses, dropdownMenuGroupComponentName, } from './dropdown-menu-group-classes';
var Title = styled(DropdownMenuItem, { name: dropdownMenuGroupComponentName, slot: 'Title' })(function (_a) {
    var theme = _a.theme;
    return (__assign(__assign({}, theme.typography.overline), { color: theme.tokens.color_fg_default, fontWeight: theme.typography.fontWeightSemibold, padding: theme.spacing(0.625, 1), borderRadius: 6 }));
});
export var DropdownMenuGroup = React.forwardRef(function (props, ref) {
    var title = props.title, children = props.children, items = props.items, 
    // do not forward onto DropdownMenuItem
    propClasses = props.classes, 
    // MenuList adds this. We need to remove to avoid focus
    tabIndex = props.tabIndex, rootProps = __rest(props, ["title", "children", "items", "classes", "tabIndex"]);
    var content = items
        ? items.map(function (itemProps, index) {
            return React.createElement(DropdownMenuListItem, __assign({ key: index }, itemProps));
        })
        : children;
    return (React.createElement(React.Fragment, null,
        !!title && (React.createElement(Title, __assign({ ref: ref, forwardedAs: "div" }, rootProps, { className: dropdownMenuGroupClasses.title }), title)),
        content));
});
